export function recolorSVG(code: string, color: string = '#000000') {
  return code.replace(/stroke=".*?"/g, `stroke=${color}`);
}

const mediaWidthBreakpoints = {
  small: 576,
  medium: 768,
  large: 992,
  extraLarge: 1200,
};

export function isScreenSizeExtraLargeAndUp() {
  return window.innerWidth >= mediaWidthBreakpoints.extraLarge;
}

function adjustCssVhVariable() {
  const vh = window.innerHeight * 0.01;
  if (document && document.documentElement && document.documentElement.style) {
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}

export function fixFullHeightInMobileBrowsers() {
  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  // for mobile browsers to exclude nav. bar height from 100% height */
  window.addEventListener('resize', () => {
    adjustCssVhVariable();
  });
  adjustCssVhVariable();
}
